import { getFormatMessage } from '@/utils/utils'
import { Table } from 'antd'
import React from 'react'
import { DriveItem, DriveTableProps } from '../interface'

export const DriveTable: React.FC<DriveTableProps> = (
  props: DriveTableProps
) => {
  const formatMessage = getFormatMessage()
  const columns = [
    {
      title: formatMessage({ id: 'app.drive.table.index' }),
      key: 'index',
      render: (text: any, record: any, index: any) => index + 1
    },
    {
      title: formatMessage({ id: 'app.drive.table.manufacturer' }),
      dataIndex: 'manufacturer',
      key: 'manufacturer'
    },
    {
      title: formatMessage({ id: 'app.drive.table.type' }),
      key: 'type',
      render: (text: any, record: DriveItem, index: any) => {
        return record.type == 0
          ? formatMessage({ id: 'app.plcType.serial' })
          : formatMessage({ id: 'app.plcType.ethernet' })
      }
    },
    {
      title: formatMessage({ id: 'app.drive.table.deviceMode' }),
      key: 'deviceMode',
      render: (text: any, record: DriveItem, index: any) => {
        return formatMessage({ id: `app.deviceMode.${record.deviceMode}` })
      }
    },
    {
      title: formatMessage({ id: 'app.drive.table.plcName' }),
      dataIndex: 'plcName',
      key: 'plcName'
    }
  ]

  return (
    <Table
      rowKey='plcId'
      columns={columns}
      dataSource={props.data}
      pagination={props.pagination}
    />
  )
}
